import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Hotel } from '../../../../components/home/home-our-properties/home-our-properties.component';
import { TabComponent } from '../../tab/tab.component';
import { DestinationsService } from '../../../../reducers/services/destinations.service';

@Component({
  selector: 'app-property-card',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './property-card.component.html',
  styleUrl: './property-card.component.scss',
})
export class PropertyCardComponent {
  @Input() hotel!: any;
  @Input() type: 'regular' | 'upcoming' = 'regular';

  getDestSlug(hotel: any): string {
    const rawSlug =
      hotel?.destinationInfo?.slug ||
      hotel?.cityInfo?.slug ||
      '';

    if (rawSlug) {
      return String(rawSlug).toLowerCase().trim();
    }

    const rawName =
      hotel?.destinationInfo?.name ||
      hotel?.cityInfo?.name ||
      '';

    return String(rawName)
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  }

  getHotelRoute(hotel: any): string[] {
    const destSlug = this.getDestSlug(hotel);

    if (destSlug && hotel?.slug) {
      return ['/our-hotels', destSlug, hotel.slug];
    }

    // safer fallback instead of broken legacy hotel URL
    return ['/our-hotels', 'all'];
  }
}
